import { ChatMessage } from '../types'

export default function mapMessages(
  newMessages: Partial<ChatMessage>[] = [],
  oldMessages: ChatMessage[] = []
): ChatMessage[] {
  const oldMessagesById = new Map(oldMessages.map(msg => [msg.id, msg]))

  const isSingleErrorMessage =
    newMessages.length === 1 && newMessages[0].error && !oldMessagesById.has(newMessages[0].id)
  if (isSingleErrorMessage) {
    return [...oldMessages, newMessages[0] as ChatMessage]
  }

  const mapped: ChatMessage[] = []
  for (const newMessage of newMessages) {
    if (null != newMessage.text) {
      // Preserve old reference when message content is unchanged to avoid unnecessary re-renders
      const oldMessage = oldMessagesById.get(newMessage.id)
      if (
        oldMessage &&
        oldMessage.text === newMessage.text &&
        oldMessage.error === newMessage.error &&
        oldMessage.like === newMessage.like
      ) {
        mapped.push(oldMessage)
      } else {
        mapped.push(newMessage as ChatMessage)
      }
    } else if (newMessage.id && oldMessagesById.has(newMessage.id)) {
      mapped.push(oldMessagesById.get(newMessage.id))
    } else {
      // oxlint-disable-next-line no-console
      console.debug('ChatAssistant[mapMessages]: unable to restore message', newMessage, [...oldMessages])
    }
  }

  return mapped
}
